var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneKeyCarConnectedMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33,0H15c-2.7568359,0-5,2.2431641-5,5v38c0,2.7568359,2.2431641,5,5,5h18c2.7568359,0,5-2.2431641,5-5V5 C38,2.2431641,35.7568359,0,33,0z M36,43c0,1.6542969-1.3457031,3-3,3H15c-1.6542969,0-3-1.3457031-3-3v-1h24V43z M36,40H12V5 c0-1.6542969,1.3457031-3,3-3h18c1.6542969,0,3,1.3457031,3,3V40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,7c-4.4111328,0-8,3.5888672-8,8c0,2.9533081,1.612915,5.5316772,4,6.9175415V27 c0,0.265625,0.1054688,0.5195312,0.2929688,0.7070312L21,28.4140625V33c0,0.265625,0.1054688,0.5195312,0.2929688,0.7070312l2,2 C23.4882812,35.9023438,23.7441406,36,24,36s0.5117188-0.0976562,0.7070312-0.2929688l2-2 C26.8945312,33.5195312,27,33.265625,27,33v-4.5859375l0.7070312-0.7070312C27.8945312,27.5195312,28,27.265625,28,27v-5.0824585 C30.387085,20.5316772,32,17.9533081,32,15C32,10.5888672,28.4111328,7,24,7z M26,26.5859375l-0.7070312,0.7070312 C25.1054688,27.4804688,25,27.734375,25,28v4.5859375l-1,1l-1-1V28c0-0.265625-0.1054688-0.5195312-0.2929688-0.7070312 L22,26.5859375v-3.8492432C22.640564,22.9025269,23.3083496,23,24,23s1.359436-0.0974731,2-0.2633057V26.5859375z M24,21 c-3.3085938,0-6-2.6914062-6-6s2.6914062-6,6-6s6,2.6914062,6,6S27.3085938,21,24,21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneKeyCarConnectedMedium);
export default __webpack_public_path__ + "static/media/phone-key-car-connected--medium.993c439afe8266cc367f313e2b9290d7.svg";
export { ForwardRef as ReactComponent };